// @ts-nocheck
import ChangeCustomerModalReducer, {
    GreifComponentsChangeCustomerModalActions,
} from "@store/Framework/Store/Greif/Components/ChangeCustomerModal/ChangeCustomerModalReducer";
import cookiePrivacyPolicyReducer, {
    GreifComponentsCookiePrivacyPolicyActions,
} from "@store/Framework/Store/Greif/Components/CookiePrivacyPolicy/CookiePrivacyPolicyReducer";
import greifOrderUploadReducer, {
    GreifComponentsOrderUploadActions,
} from "@store/Framework/Store/Greif/Components/GreifOrderUpload/GreifOrderUploadReducer";
import InviteYourColleagueFormReducer, {
    GreifComponentsInviteYourColleagueFormActions,
} from "@store/Framework/Store/Greif/Components/InviteYourColleagueForm/InviteYourColleagueFormReducer";
import LocationFiltersReducer, {
    GreifComponentsLocationFiltersActions,
} from "@store/Framework/Store/Greif/Components/LocationFilters/LocationFiltersReducer";
import RecommendedProductRequestFormReducer, {
    GreifComponentsRecommendedProductRequestFormActions,
} from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/RecommendedProductRequestFormReducer";
import SimpleQuoteFormReducer, {
    GreifComponentsSimpleQuoteFormActions,
} from "@store/Framework/Store/Greif/Components/SimpleQuoteForm/SimpleQuoteFormReducer";
import ContactUsTopicsFormReducer, {
    GreifComponentsContactUsTopicsFormActions,
} from "@store/Framework/Store/Greif/Components/ContactUsTopicsForm/ContactUsTopicsFormReducer";
import PackagingAdviceFormReducer, {
    GreifComponentsPackagingAdviceFormActions,
} from "@store/Framework/Store/Greif/Components/PackagingAdviceForm/PackagingAdviceFormReducer";
import { combineReducers } from "redux";

const componentsReducers = {
    contactUsTopicsForm: ContactUsTopicsFormReducer,
    greifOrderUpload: greifOrderUploadReducer,
    cookiePrivacyPolicy: cookiePrivacyPolicyReducer,
    inviteYourColleagueForm: InviteYourColleagueFormReducer,
    recommendedProductRequestForm: RecommendedProductRequestFormReducer,
    changeCustomerModal: ChangeCustomerModalReducer,
    locationFilters: LocationFiltersReducer,
    simpleQuoteForm: SimpleQuoteFormReducer,
    packagingAdviceForm: PackagingAdviceFormReducer,
};

export type GreifComponentsActions =
    | GreifComponentsOrderUploadActions
    | GreifComponentsCookiePrivacyPolicyActions
    | GreifComponentsInviteYourColleagueFormActions
    | GreifComponentsRecommendedProductRequestFormActions
    | GreifComponentsChangeCustomerModalActions
    | GreifComponentsLocationFiltersActions
    | GreifComponentsSimpleQuoteFormActions
    | GreifComponentsContactUsTopicsFormActions
    | GreifComponentsPackagingAdviceFormActions;

export default combineReducers(componentsReducers);
